import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  jitsiToken: "",
  isLoaded: false,
};
const jitsiSlice = createSlice({
  name: "jitsi",
  initialState,
  reducers: {
    setJitsiToken: (state, {payload}) => {
      state.jitsiToken = payload;
      state.isLoaded = true;
    },
    clearJitsiToken: (state) => {
      state.jitsiToken = "";
      state.isLoaded = false;
    },
   },
});

export const { setJitsiToken, clearJitsiToken } = jitsiSlice.actions;
export default jitsiSlice.reducer;